import React, {ReactNode} from 'react';
import { Navigate } from 'react-router-dom';

import {LS} from "../../utils";
import {LS_KEYS, ROUTES} from "../../types";

const { getFromLS } = LS;

const PrivateRoute = ({ component }: { component: ReactNode }) => {
  const isAuth = getFromLS(LS_KEYS.ACCESS_TOKEN);

  if (!isAuth) {
    return <Navigate to={ROUTES.SIGN_IN} />;
  }

  return (
    <>
      {component}
    </>
  )
};

export default PrivateRoute;
